export default __webpack_public_path__ + "static/media/baner 2.4ed9ca7a.jpg";